/**
 * Texts for header
 */
export const headerText = {
    cookiesIntroText: 'Soubory cookie používáme pouze ke sledování návštěv na našem webu, neukládáme žádné osobní údaje.',
    cookiesAccept: 'Povolit soubory cookie',
    cookiesDeny: 'Zakázat soubory cookie',
    tabFAQs: 'Často kladené otázky',
    tabSupport: 'Podpora',
    tabHistory: 'Historie',
    tabReviews: 'Příběhy',
    tabTraining: 'Školení',
    tabUserTraining: 'Uživatelské školení',
    tabHcpTraining: 'Zdravotnické školení',
    tabCamAPSLiberty: 'CamAPS Liberty',
    tabPregnancy: 'Těhotenství',
    tabAbout: 'O nás',
    tabNews: 'Novinky',
    tabCareers: 'Kariéra',
    tabOrders: '',
    tabNotifications: 'Oznámení',
};
